// extracted by mini-css-extract-plugin
export default {"totalStyle":"LowerContent_totalStyle__aaxAQ"};